import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import history from "../../utils/history";
import PatientForm from "./PatientForm";
import PractitionerForm from "./PractitionerForm";
import StudentForm from "./StudentForm";
import { useDispatch } from "react-redux";
import { getschoolList } from "../../actions/settingsActions";
const Register = () => {
  const [activeSection, setActiveSection] = useState(0);
  const [showSuccessSection, setShowSuccessSection] = useState(false);
  const [user, setUser] = useState();
  let location = useLocation();
  const dispatch = useDispatch();
  useEffect(() => {
    // setShowSuccessSection(false);
    if (location.pathname.includes("/student")) {
      setActiveSection(1);
    } else if (location.pathname.includes("/patient")) {
      setActiveSection(2);
    } else {
      setActiveSection(0);
    }
    dispatch(getschoolList());
  }, []);
  return (
    <div className="register-container">
      {showSuccessSection ? (
        <>
          <h3 className="page-title mb-4">Registration Successful</h3>
          <span className="dark-text">
            {" "}
            Dear {user?.prefix} {user?.first_name} {user?.last_name},
          </span>
          <p className="success-text mt-3">
            {" "}
            Thank you for creating an account with us!
          </p>
          <p className="success-text">
            {" "}
            An email with the activation link was sent to{" "}
            <span className="dark-text">{user?.email}</span>
          </p>
          <p className="success-text">
            {" "}
            To begin using the site{" "}
            <span className="bold-yellow">YOU WILL NEED TO ACTIVATE </span> your
            account
          </p>
          <p className="success-text">
            {" "}
            Please follow the instructions in the email.
          </p>
          {!location.pathname.includes("/patient") && (
            <p className="success-text">
              Once you have logged in, and while your registration is pending,
              you can familiarize yourself with the site and create formulas.
            </p>
          )}
        </>
      ) : (
        <>
          <h3 className="page-title">Register</h3>
          <p className="page-desc">
            To start using our online tools please fill out the appropriate form
            below to complete the registration process. Once completed, you will
            receive a verification email with an activation link.
          </p>
          <div className="row mt-4">
            <div className="tab-wrapper">
              <div
                className={`tab ${activeSection === 0 ? "selected" : ""}`}
                onClick={() => {
                  setActiveSection(0);
                  history.push("/register/practitioner");
                }}
              >
                {" "}
                <h2>Practitioner Registration</h2>
              </div>
              <div
                className={`tab ${activeSection === 1 ? "selected" : ""}`}
                onClick={() => {
                  setActiveSection(1);
                  history.push("/register/student");
                }}
              >
                <h2>Student Registration</h2>
              </div>
              <div
                className={`tab ${activeSection === 2 ? "selected" : ""}`}
                onClick={() => {
                  setActiveSection(2);
                  history.push("/register/patient");
                }}
              >
                <h2>Patient Registration</h2>
              </div>
            </div>
            <div className="col-sm-12">
              <div className="detail-wrapper">
                {activeSection === 0 && (
                  <PractitionerForm
                    setShowSuccessSection={setShowSuccessSection}
                    setUser={setUser}
                  />
                )}
                {activeSection === 1 && (
                  <StudentForm
                    setShowSuccessSection={setShowSuccessSection}
                    setUser={setUser}
                  />
                )}
                {activeSection === 2 && (
                  <PatientForm
                    setShowSuccessSection={setShowSuccessSection}
                    setUser={setUser}
                  />
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default Register;
